module.exports = __webpack_public_path__ + "img/Logo_kickdun_white.fa985198.png";